import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-user-online',
  templateUrl: './text-user-online.component.html',
  styleUrls: ['./text-user-online.component.scss']
})
export class TextUserOnlineComponent {
  @Input() isActual = true;
  @Input() last_seen: any;
  @Input() online: any;
  constructor() {}

}
